module.exports = __webpack_public_path__ + "img/icon-enquete.3692b0aa.svg";